import { createHeroView, createNavigationView } from './index'
import { SEARCH_TYPE_ADVERTS } from '../components/Arena/constants'

const Arena = () => import('../components/Arena/Arena.vue')
const AdvertDetailsAuthenticator = () => import('../components/Arena/AdvertDetailsAuthenticator.vue')
const BidModalAuthenticator = () => import('../components/Arena/BidModalAuthenticator.vue')
const BidsModalAuthenticator = () => import('../components/BidSessions/BidsModalAuthenticator.vue')

export const routes = () => [
  { path: '/arena', redirect: '/borze' },
  {
    path: '/borze',
    components: {
      default: Arena,
      hero: createHeroView('arena'),
      navigation: createNavigationView('static')
    },
    props: {
      default: route => ({
        type: SEARCH_TYPE_ADVERTS,
        isSearchFormVisible: true,
        occupationName: route.query.occupationName,
        workLocationId: route.query.workLocationId ? +route.query.workLocationId : undefined,
        workWholeCountry: route.query.workWholeCountry
          // eslint-disable-next-line eqeqeq
          ? route.query.workWholeCountry == 'true' || route.query.workWholeCountry
          : false
      })
    },
    children: [
      {
        path: 'ajanlat/:id/elozmeny',
        component: BidsModalAuthenticator,
        props: true,
        meta: {
          isModal: true
        }
      },
      {
        path: 'hirdetes/:id/ajanlat',
        component: BidModalAuthenticator,
        props: true,
        meta: {
          isModal: true
        }
      },
      {
        path: 'hirdetes/:id',
        component: AdvertDetailsAuthenticator,
        props: route => ({ id: route.params.id }),
        meta: {
          isModal: true
        }
      }
    ],
    meta: {
      pageTitle: 'Stock Exchange'
    }
  },
  {
    path: '/gyakornoki-borze',
    components: {
      default: Arena,
      hero: createHeroView('intern-arena'),
      navigation: createNavigationView('static')
    },
    props: {
      default: route => ({
        type: SEARCH_TYPE_ADVERTS,
        isSearchFormVisible: true,
        occupationName: route.query.occupationName,
        workLocationId: route.query.workLocationId ? +route.query.workLocationId : undefined,
        workWholeCountry: route.query.workWholeCountry
          // eslint-disable-next-line eqeqeq
          ? route.query.workWholeCountry == 'true' || route.query.workWholeCountry
          : false,
        isInternArena: true
      })
    },
    children: [
      {
        path: 'ajanlat/:id/elozmeny',
        component: BidsModalAuthenticator,
        props: true,
        meta: {
          isModal: true,
          theme: 'blue'
        }
      },
      {
        path: 'hirdetes/:id/ajanlat',
        component: BidModalAuthenticator,
        props: true,
        meta: {
          isModal: true,
          theme: 'blue'
        }
      },
      {
        path: 'hirdetes/:id',
        component: AdvertDetailsAuthenticator,
        props: route => ({ id: route.params.id }),
        meta: {
          isModal: true,
          theme: 'blue'
        }
      }
    ],
    meta: {
      pageTitle: 'Intern Stock Exchange',
      theme: 'blue'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/arena.js